import { device } from 'app/ui-components/breakpoints';
import SvgIcon, { SVG_ICONS } from 'app/ui-components/SvgIcon/SvgIcon';
import { StyledIconBackground } from 'app/ui-components/SvgIcon/SvgIcon.styles';
import styled, { css } from 'styled-components';
import {
    iconBan,
    iconPlay,
    playTransitionCubicEaseInOut,
    regularBlack,
    regularWhite,
} from '../../../design-tokens';
import PlayImage from '../../../PlayImage/PlayImage';
import { playFontIcon, playFontSize } from '../../../typography/helpers';
import { ContentItemLink } from '../../ContentItem.styles';

export const StyledPlayIcon = styled(SvgIcon).attrs({ icon: SVG_ICONS.PLAY_OPAQUE, width: 50 })`
    position: absolute;
    top: 50%;
    left: calc(50%);
    z-index: 10;
    transform: translate(-50%, -50%);
    width: 40px;
    display: flex;
    opacity: 0;

    @media ${device.GteMedium} {
        left: calc(50%);
        width: 50px;
    }

    .touchevents & {
        top: unset;
        bottom: 5px;
        left: 5px;
        transform: none;
        display: block;
        width: 30px;
        opacity: 1;
    }

    .no-touchevents.no-sweden && {
        ${(props) =>
            props.onlyAvailableInSweden &&
            css`
                display: none !important;
            `}
    }

    ${(props) =>
        props.onlyAvailableInSweden &&
        css`
            .no-sweden && {
                display: none;
                opacity: 0;
            }
        `}

    /* stylelint-disable */
    ${ContentItemLink}:hover & {
        /* stylelint-enable */

        .no-touchevents & {
            transition: opacity 120ms ${playTransitionCubicEaseInOut};
            opacity: 1;
            color: ${regularBlack};
            width: 100px;
            background-color: ${regularWhite};
            ${playFontSize(1.3)}
            text-transform: uppercase;
            font-weight: 700;
            border-radius: 33px;
            height: 37px;
            display: flex;
            justify-content: left;
            align-items: center;

            ${StyledIconBackground} {
                display: none;
            }

            &:before {
                ${playFontIcon(2.3, iconPlay)}
                margin-left: 10px;
            }

            &:after {
                content: 'Spela';
                margin-left: 4px;
            }
        }
    }
`;

export const StyledContentItemFigure = styled(PlayImage)`
    transition: transform 0.2s ${playTransitionCubicEaseInOut};
    transform-origin: center;
    overflow: hidden;

    ${(props) =>
        props.onlyAvailableInSweden &&
        !props.editModeActivated &&
        css`
            .no-sweden && :after {
                font-family: svt-icons;
                content: '${iconBan}';
                position: absolute;
                margin-top: -0.5em;
                margin-left: -0.5em;
                top: 50%;
                left: 50%;
                z-index: 10;
                text-align: center;
                color: ${regularWhite};
                color: rgba(255, 255, 255, 0.65);
                ${playFontSize(4.5)}
            }
        `}

    /* stylelint-disable */
    ${ContentItemLink}:hover & {
        /* stylelint-enable */
        transform: scale(1.02);
    }
`;

export const Overlay = styled.div`
    position: absolute;
    top: 0;
    width: 100%;
    height: 100.5%;
    z-index: 10;
    text-align: center;
    color: ${regularWhite};
    color: rgba(255, 255, 255, 0.65);
`;

export const OutsideSwedenOverlay = styled(Overlay)`
    display: none;

    .no-sweden && {
        display: block;
    }
`;
